<template>
  <div class="cmcc">
    <div class="cmcc-main">
      <img src="./assets/image_01.png" alt="">
      <img src="./assets/image_02.png" alt="">
      <img src="./assets/image_03.png" alt="">
      <img src="./assets/image_04.jpg" alt="">
      <img src="./assets/image_05.png" @click="receive" alt="">
    </div>
    <Notice ref="notice" class="notice" :closeBtn="true">
      <img @click="copy" src="./assets/bubble.png" id="clip-click" alt="" data-clipboard-action="copy" data-clipboard-text="微课">
    </Notice>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../../modules/activity/cmcc'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Notice from '../../components/Notice'
import clipboard from 'clipboard'
import login from '@edu-fe/login'

export default {
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    receive () {
      this.$refs.notice.show()
    },
    copy () {
      if (clipboard.isSupported()) {
        const clip = new clipboard('#clip-click');
        clip.on('success', e => {
          alert('复制成功')
          clip.destroy();
        });
        clip.on('error', e => {
          clip.destroy();
        });
      }
    }
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },

  async created () {
    const wpsSid = await login.getWpsSid()
    if (!wpsSid) {
      login.login()
    }
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },
  components: {
    Notice
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.cmcc {
  font-size: 0;
  &-main {
    > img {
      width: 100%;
    }
  }
  &-btn {
    /*position: absolute;*/
    /*width: rem(450);*/
    /*bottom: rem(40);*/
    left: 50%;
    transform: translateX(-50%);
    > img {
      width: 100%;
    }
  }
  .notice {
    &-content {
      background: none;
      > img {
        width: 100%;
      }
    }
  }
}
</style>
